import { render, staticRenderFns } from "./CadrePlatform.vue?vue&type=template&id=8996d96c&scoped=true&"
import script from "./CadrePlatform.vue?vue&type=script&lang=js&"
export * from "./CadrePlatform.vue?vue&type=script&lang=js&"
import style0 from "./CadrePlatform.vue?vue&type=style&index=0&id=8996d96c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8996d96c",
  null
  
)

export default component.exports